/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeFrequenceDisciplineViewModel } from "../types/GradeFrequenceDisciplineViewModel.ts";
import { gradeFrequenceClassViewModelSchema } from "./gradeFrequenceClassViewModelSchema.ts";

export const gradeFrequenceDisciplineViewModelSchema = z.object({
  disciplineId: z.optional(z.number().int()),
  name: z.string().nullish(),
  firstClassDate: z.optional(z.string().date()),
  lastClassDate: z.optional(z.string().date()),
  classes: z.array(z.lazy(() => gradeFrequenceClassViewModelSchema)).nullish(),
  classesCount: z.optional(z.number().int()),
  showOnStudentDocument: z.optional(z.boolean()),
  isIncludedInGradeCalculation: z.optional(z.boolean()),
  isIncludedInAttendanceCalculation: z.optional(z.boolean()),
}) as unknown as ToZod<GradeFrequenceDisciplineViewModel>;
